import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Services } from '../components/Services';
import { Extras } from '../components/Extras';
import { ServiceGrid } from '../components/ServiceGrid';
import { CallCta } from '../components/CallCta';
import { usePageMeta } from '../hooks/usePageMeta';
import { packages } from '../data/packages';
import { SITE_URL, BUSINESS_ID } from '../utils/seo';
export function ServicesPage() {
  usePageMeta({
    title: "Mobile Detailing Services & Pricing | Mike's Pro Detail",
    description: "Full Detail, Wash & Wax, Basic Wash, and Interior Detail packages with transparent pricing, plus add-on services. Mobile car detailing across Ventura County. Call or text 818-381-9905.",
    path: '/services',
    breadcrumbName: 'Services',
    extraGraph: [{
      '@type': 'OfferCatalog',
      '@id': `${SITE_URL}/services#catalog`,
      name: 'Mobile car detailing packages',
      provider: {
        '@id': BUSINESS_ID
      },
      itemListElement: packages.map(pkg => ({
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: pkg.name,
          url: `${SITE_URL}${pkg.path}`
        },
        price: pkg.priceSm.replace('$', ''),
        priceCurrency: 'USD'
      }))
    }]
  });
  return <main data-id="element-1098" data-mp="2jkjgd893exxq">
      <PageHeader breadcrumb="Services" title="Detailing Services" subtitle="Every package, add-on, and price in one place — performed at your home or office anywhere in Ventura County." data-id="element-1099" data-mp="2jl1jmou6acf5" />
      <Services data-id="element-1100" data-mp="3baxmgiav75yu" />
      <Extras data-id="element-1101" data-mp="3bch34a0fnj15" />
      <ServiceGrid data-id="element-1102" data-mp="3bcqxe9sigccn" />
      <CallCta data-id="element-1103" data-mp="3bdir1f2js00a" />
    </main>;
}